import React from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
  ButtonBase,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { NavItem } from "../../types/navTypes";

interface SideBarItemProps {
  item: NavItem;
  isSideBarOpen: boolean;
  onClick?: () => void;
}

export const SideBarItem: React.FC<SideBarItemProps> = ({
  item,
  isSideBarOpen,
  onClick,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    if (item.children) {
      setOpen(!open);
    }
    onClick?.(); 
  };

  const Content = (
    <>
      <ListItemIcon>{item.icon}</ListItemIcon>
      {isSideBarOpen && <ListItemText primary={item.title} />}
      {isSideBarOpen && item.children && (open ? <ExpandLess /> : <ExpandMore />)}
    </>
  );

  return (
    <>
      {item.isModal ? (
        <ListItem button component={ButtonBase} onClick={handleClick}>
          {Content}
        </ListItem>
      ) : (
        <ListItem button component={Link} to={item.path || "#"} onClick={handleClick}>
          {Content}
        </ListItem>
      )}

      {item.children && isSideBarOpen && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map((child, index) => (
              <SideBarItem
                key={index}
                item={child}
                isSideBarOpen={isSideBarOpen}
                onClick={onClick}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};
